// extracted by mini-css-extract-plugin
export var label = "_cv-5";
export var slideContainer = "_cv-0";
export var slider = "_cv-1";
export var sliderLg = "_cv-4";
export var sliderMd = "_cv-3";
export var sliderSm = "_cv-2";